import { styled } from 'styled-components';
import { IArticleBox1, defaultParams } from './params';
import { IGlobaVariables } from './../../../components/Layout/styles';

const Styles = styled.div<{
  theme?: IGlobaVariables;
  $config: IArticleBox1;
}>`
  .article-box {
    position: relative;
    width: 100%;
    height: 100%;
    border: ${({ $config: styles }) => styles.border};
    border-radius: ${({ $config: styles }) => styles.borderRadius};
    background: ${({ $config: styles }) => styles.backgroundColor};
    padding: 15px 15px 55px;

    &-image {
      display: block;
      width: 100%;
      aspect-ratio: 225 / 160;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &-content {
      padding: 15px 0 0;
      word-break: break-word;
    }

    &-category {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 5px;
      color: ${({ $config: styles }) => styles.group_category.color};
      font-family: ${({ $config: styles }) => styles.group_category.fontFamily};
      font-weight: ${({ $config: styles }) => styles.group_category.fontWeight};
      font-size: ${({ $config: styles }) => styles.group_category.fontSize};
      line-height: ${({ $config: styles }) => styles.group_category.lineHeight};
      text-decoration: ${({ $config: styles }) => styles.group_category.textDecoration};
      margin-bottom: 12px;

      svg {
        color: ${({ $config: styles }) => styles.group_category.group_arrow.color};
      }

      &:hover {
        color: ${({ $config: styles }) => styles.group_category.hover_color};
        text-decoration: ${({ $config: styles }) => styles.group_category.hover_textDecoration};
        svg {
          color: ${({ $config: styles }) => styles.group_category.group_arrow.hover_color};
        }
      }

      &.disabled {
        pointer-events: none;
        color: ${({ $config: styles }) => styles.group_category_disabled.color};
        text-decoration: ${({ $config: styles }) => styles.group_category_disabled.textDecoration};
        svg {
          color: ${({ $config: styles }) => styles.group_category_disabled.color};
        }
      }
    }

    &-title {
      line-height: ${({ $config: styles }) => styles.group_title.lineHeight};
      a {
        color: ${({ $config: styles }) => styles.group_title.color};
        font-family: ${({ $config: styles }) => styles.group_title.fontFamily};
        font-weight: ${({ $config: styles }) => styles.group_title.fontWeight};
        font-size: ${({ $config: styles }) => styles.group_title.fontSize};
        text-decoration: ${({ $config: styles }) => styles.group_title.textDecoration};
        &:hover {
          color: ${({ $config: styles }) => styles.group_title.hover_color};
          text-decoration: ${({ $config: styles }) => styles.group_title.hover_textDecoration};
        }
      }
    }

    &-description {
      color: ${({ $config: styles }) => styles.group_description.color};
      font-family: ${({ $config: styles }) => styles.group_description.fontFamily};
      font-weight: ${({ $config: styles }) => styles.group_description.fontWeight};
      font-size: ${({ $config: styles }) => styles.group_description.fontSize};
      line-height: ${({ $config: styles }) => styles.group_description.lineHeight};
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow-wrap: break-word;
      overflow: hidden;
      margin: 0;
    }

    &-button {
      position: absolute;
      bottom: -22.5px;
      left: calc(50% - 22.5px);
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 45px;
      height: 45px;
      background: ${({ $config: styles }) => styles.group_button.backgroundColor};
      border: ${({ $config: styles }) => styles.group_button.border};
      border-radius: ${({ $config: styles }) => styles.group_button.borderRadius};
      color: ${({ $config: styles }) => styles.group_button.color};
      transform: rotate(0);
      transition: 0.2s all ease-in;
      box-sizing: border-box;
      svg {
        width: 25px;
        height: 25px;
        transform: rotate(0);
        transition: transform 0.2s ease-in;
      }
      &:hover {
        background: ${({ $config: styles }) => styles.group_button.hover_backgroundColor};
        border: ${({ $config: styles }) => styles.group_button.hover_border};
        border-radius: ${({ $config: styles }) => styles.group_button.hover_borderRadius};
        color: ${({ $config: styles }) => styles.group_button.hover_color};
        border-radius: ${({ $config: styles }) => styles.group_button.hover_borderRadius};
        transform: rotate(45deg);

        svg {
          transform: rotate(-45deg);
        }
      }
    }
  }
`;

export default Styles;
